import React from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import Button from '@material-ui/core/Button';

import Header from '../../../../../../../components/Stake/header';
import * as fxfStakeActions from '../../../../../../../actions/fxf-stake-actions';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import FxfIcon from '../../../../../../../assets/images/tokens/fxf-icon.svg';
import { FXF } from '../../../../../../../constants/blockchain-constants';

import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-information.module.scss';

const UnstakeInformation = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  return (
    <>
      <Header
        icon={FxfIcon}
        title={`${FXF}-Unstaking`}
        onClickBack={() => dispatch(fxfStakeActions.unstakeSettings())}
      />
      <div
        className={cn(stylesParent.cardContent, styles.unstaking)}
        style={{ color: colors.text }}
      >
        <div className={styles.title}>Withdrawal Timer Reset!</div>
        <div className={styles.description}>0 day for unstaking time.</div>
        <Button
          onClick={() => dispatch(fxfStakeActions.unstakeDetails())}
          variant='contained'
          color='secondary'
          className={cn(stylesParent.cardFooterControlsButton, styles.button)}
        >
          Continue
        </Button>
        {/*<div className={styles.description}>*/}
        {/*  <span>IMPORTANT:</span>&nbsp;*/}
        {/*  <b>*/}
        {/*    You are able to unstake your tokens immediately by paying a 10% fee on your current*/}
        {/*    unstaking amount.*/}
        {/*  </b>*/}
        {/*</div>*/}
        {/*<Button*/}
        {/*  onClick={() => dispatch(fxfStakeActions.unstakeImmediatelyDetails())}*/}
        {/*  variant='contained'*/}
        {/*  color='secondary'*/}
        {/*  className={cn(stylesParent.cardFooterControlsButton, styles.button)}*/}
        {/*>*/}
        {/*  Unstake Immediately*/}
        {/*</Button>*/}
      </div>
    </>
  );
};

export default UnstakeInformation;
